module.exports = __webpack_public_path__ + "static/img/23-红英小学(唐家岭校区).0df361c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/23-红英小学(唐家岭校区).png
// module id = VJXX
// module chunks = 0